module.exports = "<forms-questions-actions-update\n    question=\"vm.question\"\n    back-to-list-with-params=\"'authorized.forms.questions.all.list'\"\n    form=\"vm.form\"\n    sites=\"vm.sites\"\n    question-pools=\"vm.questionPools\"\n    meta-field-groups=\"vm.metaFieldGroups\"></forms-questions-actions-update>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/questions/all/question/template.html
// module id = 1607
// module chunks = 0